/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".imageUrl[_ngcontent-%COMP%]{height:auto;width:100vw;margin:0 auto}\n/*# sourceMappingURL=rideGuarantee-webview.component.css.map*/"];
export { styles as styles };
